module.exports = __webpack_public_path__ + "static/media/ic_how_to_claim_myway.431f9fcb.svg";